module.exports = __webpack_public_path__ + "assets/img/front.45057357.png";